import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ApexOptions } from 'ng-apexcharts';
import { PieChartData, SelectablePeriod } from 'app/modules/user/dashboard/dashboard.types';

@Component({
  selector: 'app-card-with-pie-chart',
  templateUrl: './card-with-pie-chart.component.html',
  styleUrls: ['./card-with-pie-chart.component.scss']
})
export class CardWithPieChartComponent implements OnInit, OnChanges {
    @Input() chartOptions: ApexOptions;
    @Input() titleKey: string;
    @Input() data?: PieChartData;
    @Input() selectedPeriod: SelectablePeriod;
    @Input() selectablePeriods: SelectablePeriod[];
    @Output() readonly onPeriodChanged: EventEmitter<SelectablePeriod> = new EventEmitter<SelectablePeriod>();

    tableData: PieChartData;

  constructor() { }
    ngOnInit(): void {
    }

  ngOnChanges(): void {
      if (this.data) {
          this.tableData = this.data;
      } else {
        if (this.chartOptions?.series?.length) {
            this.tableData = {
                series: this.chartOptions.series as number[],
                labels: this.chartOptions.labels
            }
          }
      }
  }

  hasValues(): boolean {
    return !!this.tableData?.values?.length;
  }

  periodChanged(period: SelectablePeriod): void {
    this.onPeriodChanged.emit(period);
}
}
